import { useMemo } from 'react';

const useStorageKey = currentProfileId => {
  const setStorageKey = () => {
    if (currentProfileId) {
      return currentProfileId;
    } else {
      return 'no_profile_id';
    }
  };

  const storageKey = useMemo(() => setStorageKey(), [currentProfileId]);

  return storageKey;
};

export default useStorageKey;
